export default "__VITE_ASSET__BAfL1VMy__"